// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1a1a1a;
  }
  .dashboard__container {
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: var(--surface-bg);
    padding: 30px;
    border-radius: 8px;
    border: 1px solid var(--wire-purple);
    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .dashboard__btn {
    padding: 10px;
    font-size: 18px;
    margin-top: 10px;
    border: 1px solid var(--wire-purple);
    color: white;
    background-color: var(--btn-bg);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .dashboard__btn:hover {
    background-color: var(--btn-bg-hover);
    box-shadow: 0 0 10px rgba(201, 168, 255, 0.4);
  }
  .dashboard__nav {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 20px 0;
    width: 100%;
    max-width: 300px;
  }
  .dashboard__nav-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 15px 20px;
    font-size: 16px;
    border: 1px solid;
    color: white;
    background-color: #232323;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
  }
  .dashboard__nav-btn:hover {
    transform: translateY(-2px);
    background-color: #1f1f1f;
    opacity: 0.95;
  }

  /* Wireframe borders: neon pastel tints of the original accent colors */
  .dashboard__nav-btn--shopping {
    border-color: #a5f3b0;
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
  }
  .dashboard__nav-btn--shopping:hover {
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
  }

  .dashboard__nav-btn--vault {
    border-color: #a8d8ff;
    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
  }
  .dashboard__nav-btn--vault:hover {
    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
  }

  .dashboard__nav-btn--users {
    border-color: #ffd9a8;
    box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
  }
  .dashboard__nav-btn--users:hover {
    box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);
  }

  .dashboard__nav-btn--recipes {
    border-color: #a8f0f7;
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);
  }
  .dashboard__nav-btn--recipes:hover {
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 0 0 10px rgba(168, 240, 247, 0.4);
  }
  .dashboard div {
    margin-top: 7px;
  }

@media (max-width: 768px) {
  .dashboard__container {
    padding: 20px;
    margin: 20px;
  }
  
  .dashboard__nav {
    max-width: none;
  }
  
  .dashboard__nav-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,mFAAmF;EACrF;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,qCAAqC;IACrC,6CAA6C;EAC/C;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;EACf;;EAEA,uEAAuE;EACvE;IACE,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,wFAAwF;EAC1F;;EAEA;IACE,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,wFAAwF;EAC1F;;EAEA;IACE,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,wFAAwF;EAC1F;;EAEA;IACE,qBAAqB;IACrB,qDAAqD;EACvD;EACA;IACE,wFAAwF;EAC1F;EACA;IACE,eAAe;EACjB;;AAEF;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".dashboard {\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #1a1a1a;\n  }\n  .dashboard__container {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    background-color: var(--surface-bg);\n    padding: 30px;\n    border-radius: 8px;\n    border: 1px solid var(--wire-purple);\n    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  .dashboard__btn {\n    padding: 10px;\n    font-size: 18px;\n    margin-top: 10px;\n    border: 1px solid var(--wire-purple);\n    color: white;\n    background-color: var(--btn-bg);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  .dashboard__btn:hover {\n    background-color: var(--btn-bg-hover);\n    box-shadow: 0 0 10px rgba(201, 168, 255, 0.4);\n  }\n  .dashboard__nav {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin: 20px 0;\n    width: 100%;\n    max-width: 300px;\n  }\n  .dashboard__nav-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 15px 20px;\n    font-size: 16px;\n    border: 1px solid;\n    color: white;\n    background-color: #232323;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-decoration: none;\n  }\n  .dashboard__nav-btn:hover {\n    transform: translateY(-2px);\n    background-color: #1f1f1f;\n    opacity: 0.95;\n  }\n\n  /* Wireframe borders: neon pastel tints of the original accent colors */\n  .dashboard__nav-btn--shopping {\n    border-color: #a5f3b0;\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n  }\n  .dashboard__nav-btn--shopping:hover {\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n  }\n\n  .dashboard__nav-btn--vault {\n    border-color: #a8d8ff;\n    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n  }\n  .dashboard__nav-btn--vault:hover {\n    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n  }\n\n  .dashboard__nav-btn--users {\n    border-color: #ffd9a8;\n    box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n  }\n  .dashboard__nav-btn--users:hover {\n    box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);\n  }\n\n  .dashboard__nav-btn--recipes {\n    border-color: #a8f0f7;\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);\n  }\n  .dashboard__nav-btn--recipes:hover {\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 0 0 10px rgba(168, 240, 247, 0.4);\n  }\n  .dashboard div {\n    margin-top: 7px;\n  }\n\n@media (max-width: 768px) {\n  .dashboard__container {\n    padding: 20px;\n    margin: 20px;\n  }\n  \n  .dashboard__nav {\n    max-width: none;\n  }\n  \n  .dashboard__nav-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
